import CurrentUser from 'models/CurrentUser';
import { ISubscription } from 'models/Subscription';

class Impact {
  static trackSignup(user: CurrentUser, subscription: ISubscription): void {
    const { signup_summary: signupSummary } = subscription;

    if (window.ire) {
      window.ire('trackConversion', IMPACT_ACCOUNT_ID, {
        orderId: subscription.id,
        customerId: user.id.toString(),
        customerEmail: user.email,
        customerStatus: 'active',
        currencyCode: 'USD',
        orderPromoCode: signupSummary.discount.coupon_name,
        items: [{
          subTotal: signupSummary.box_total,
          category: user.subscription.plan,
          sku: user.subscription.plan,
          quantity: 1,
          name: user.subscription.plan,
        }],
      }, {
        verifySiteDefinitionMatch: true,
      });
    }
  }
}

export default Impact;
